var _circle, _circle2, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8002,
    cy: 37.9554,
    r: 37.3002,
    stroke: "white",
    strokeDasharray: "3.57 3.57"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.8035,
    cy: 37.9553,
    r: 30.9988,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5813 55.9573C44.9757 55.9595 45.3666 55.8832 45.7312 55.7328C46.0958 55.5824 46.4267 55.3609 46.7048 55.0811L50.729 51.0569C51.0056 50.7787 51.1609 50.4023 51.1609 50.01C51.1609 49.6177 51.0056 49.2413 50.729 48.9631L44.7892 43.0232C44.511 42.7467 44.1346 42.5914 43.7423 42.5914C43.35 42.5914 42.9736 42.7467 42.6954 43.0232L40.3194 45.3843C38.6745 44.9457 37.151 44.1383 35.8645 43.0232C34.7525 41.7347 33.9454 40.212 33.5035 38.5683L35.8645 36.1924C36.1411 35.9142 36.2964 35.5378 36.2964 35.1455C36.2964 34.7532 36.1411 34.3768 35.8645 34.0986L29.9247 28.1587C29.6465 27.8822 29.2701 27.7269 28.8778 27.7269C28.4855 27.7269 28.1091 27.8822 27.8309 28.1587L23.8215 32.1978C23.5418 32.4759 23.3202 32.8069 23.1698 33.1715C23.0194 33.5361 22.9431 33.927 22.9454 34.3213C23.0801 40.027 25.36 45.4724 29.3307 49.5719C33.4303 53.5426 38.8756 55.8226 44.5813 55.9573ZM28.8852 31.3217L32.7313 35.1678L30.8157 37.0834C30.6342 37.2533 30.4984 37.4661 30.4205 37.7022C30.3427 37.9383 30.3254 38.1902 30.3702 38.4347C30.9252 40.9151 32.1003 43.2143 33.7856 45.117C35.6869 46.8045 37.9866 47.9799 40.4679 48.5325C40.7088 48.5828 40.9583 48.5725 41.1942 48.5025C41.4301 48.4325 41.6449 48.3051 41.8193 48.1315L43.7349 46.1714L47.5809 50.0174L44.611 52.9873C39.6864 52.8605 34.9877 50.8952 31.4394 47.4781C28.0134 43.9283 26.0424 39.2234 25.9153 34.2916L28.8852 31.3217ZM49.6747 39.6227H52.6446C52.6831 37.857 52.3638 36.1019 51.7058 34.463C51.0478 32.8241 50.0647 31.3354 48.816 30.0867C47.5672 28.8379 46.0785 27.8549 44.4396 27.1969C42.8007 26.5389 41.0456 26.2195 39.28 26.258V29.2279C40.6579 29.1803 42.0309 29.4165 43.3136 29.922C44.5963 30.4276 45.7613 31.1915 46.7362 32.1664C47.7111 33.1413 48.4751 34.3064 48.9806 35.5891C49.4861 36.8718 49.7224 38.2448 49.6747 39.6227Z",
    fill: "url(#paint0_linear_1248_1203)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2812 35.1677C42.3997 35.1677 43.7361 36.5041 43.7361 39.6226H46.7061C46.7061 34.841 44.0628 32.1978 39.2812 32.1978V35.1677Z",
    fill: "url(#paint1_linear_1248_1203)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_1203",
    x1: 37.7965,
    y1: 26.2549,
    x2: 37.7965,
    y2: 55.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_1203",
    x1: 42.9937,
    y1: 32.1978,
    x2: 42.9937,
    y2: 39.6226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69A4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69A4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.7cb87689086135b5f0aa4771ab81b158.svg";
export { ForwardRef as ReactComponent };